module.exports = __webpack_public_path__ + "static/media/plus.d2ae7442.svg";